import * as React from 'react';
import {
    Route,
    Switch,
    RouteComponentProps,
} from "react-router-dom";
import SkynetPage from './Skynet';
import SkynetDetailPage from './pages/SkynetDetail';
import SkynetTranscriptionDetailPage from './pages/SkynetTranscriptionDetail';

type TParams = { id: string, url: string }

function Search({ match }: RouteComponentProps<TParams>) {
    return (
        <Switch>
          <Route exact path={`${match.url}`} component={SkynetPage} />
          <Route exact path={`${match.url}/transcription/:vmId`} component={SkynetTranscriptionDetailPage} />
          <Route exact path={`${match.url}/:vmId`} component={SkynetDetailPage} />
        </Switch>
    );
}

export default Search;
